import type { Bonus } from '../types/content'

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: '150 Pickleball Drills Library',
    headline:
      'A Complete Ready-to-Use Drill Collection for Building Skills, Improving Consistency, and Creating Better Pickleball Sessions',
    value: '27',
    points: [
      'A complete library of 150 practical drills organized by skill, level, and training objective — ready to use immediately without any preparation.',
      'Covers serving, returns, forehand, backhand, dinking, volleys, resets, transition play, third shots, footwork, positioning, doubles movement, accuracy, consistency, reaction speed, and pressure situations.',
      'Each drill is designed so you can quickly understand the objective, setup, execution, coaching focus, progressions, and practical application.',
    ],
    benefit:
      'It keeps your sessions fresh, eliminates the constant search for new drills, and gives you variety built directly into the system.',
  },
  {
    id: '2',
    title: '100 Common Pickleball Mistakes, Coaching Cues & Corrections',
    headline:
      'A Complete Instructor Reference to Identify Problems Faster, Correct Technique Clearly, and Improve Player Performance',
    value: '27',
    points: [
      'A practical reference covering 100 of the most common pickleball errors and exactly how to correct them.',
      'Covers serving, returns, forehand, backhand, footwork, dinking, volleys, resets, third shots, transition play, kitchen positioning, doubles movement, communication, shot selection, and match decisions.',
      'For each error you get: what the player is doing wrong, the likely cause, what to observe, how to correct it, the recommended coaching cue, and a practical drill or adjustment.',
    ],
    benefit:
      'Stop giving vague feedback. Identify problems faster and deliver concrete, specific corrections every time.',
  },
  {
    id: '3',
    title: '75 Pickleball Games, Challenges & Competitive Activities',
    headline:
      'A Complete Ready-to-Run Activity Collection to Make Pickleball Sessions More Engaging, Competitive, and Skill-Focused',
    value: '19',
    points: [
      '75 games, challenges, and competitive activities ready to use in private lessons, small groups, clinics, and full classes.',
      'Covers serving, returns, groundstrokes, dinking, volleys, third shots, resets, transition, footwork, doubles, accuracy, consistency, communication, and point construction.',
      'Each activity includes objective, setup, player format, rules, scoring, coaching focus, progressions, and level adaptations.',
    ],
    benefit:
      'Turn traditional drills into competitive, engaging experiences that keep players invested — while developing specific, measurable skills.',
  },
  {
    id: '4',
    title: 'Player Assessment, Skill Rating & Progress Tracking System',
    headline:
      'A Complete Instructor Toolkit to Evaluate Players, Identify Weaknesses, Track Improvement, and Build Clear Development Plans',
    value: '19',
    points: [
      'A complete system for evaluating players and tracking their development over time.',
      'Includes initial assessments, skill checklists, technical evaluations, tactical evaluations, benchmark tests, lesson notes, goal setting, progress tracking, retesting, and development pathways.',
      'Covers serves, returns, groundstrokes, dinks, volleys, third shots, resets, transition, footwork, positioning, doubles, communication, consistency, and decision-making. Works with beginners, intermediate players, and advanced players.',
    ],
    benefit:
      'Demonstrate progress, identify weaknesses, and build a much clearer development path for every single player you work with.',
  },
  {
    id: '5',
    title: '50 Done-for-You Pickleball Clinics & Emergency Lesson Plans',
    headline:
      'A Complete Ready-to-Teach Session Library for Beginner, Intermediate, Advanced, Mixed-Level, and Last-Minute Pickleball Classes',
    value: '19',
    points: [
      '50 complete clinic plans and lesson plans ready to use immediately — for private lessons, small groups, clinics, and full classes at every level.',
      'Includes sessions of 45, 60, and 90 minutes. Covers beginner fundamentals, serving, returning, groundstrokes, dinking, volleys, third shots, resets, transition, footwork, doubles movement, positioning, communication, strategy, and match play.',
      'Each plan includes objectives, setup, warm-up, teaching sequence, drills, coaching cues, progressions, scoring, game application, and closing review.',
    ],
    benefit:
      "This is your emergency resource. If you didn't have time to prepare anything, open a session and start teaching.",
  },
]

export const bonusValueRows = [
  { label: '150 Drills Library', value: '$27' },
  { label: '100 Mistakes & Corrections', value: '$27' },
  { label: '75 Games & Competitive Activities', value: '$19' },
  { label: 'Player Assessment & Tracking System', value: '$19' },
  { label: '50 Done-for-You Clinics & Emergency Plans', value: '$19' },
]
